import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

export default class ProviderAppRedirect extends Component {
  isLocalhost() {
    const hostname = window.location.hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
  }

  componentDidMount() {
    // Only perform external redirects for non-localhost environments
    if (!this.isLocalhost()) {
      const hostname = window.location.hostname;
      
      // Determine redirect URL based on hostname
      let redirectUrl;
      if (hostname === 'dashboard-hu.bookkeepie.com') {
        // Production environment
        redirectUrl = 'https://app-hu.bookkeepie.com/';
      } else if (hostname === 'dev-hu.bookkeepie.com') {
        // Dev environment
        redirectUrl = 'https://app-hu-dev.bookkeepie.com/';
      } else {
        // Fallback to dev environment for unknown hostnames
        redirectUrl = 'https://app-hu-dev.bookkeepie.com/';
      }
      
      // Perform external redirect
      window.location.href = redirectUrl;
    }
  }

  render() {
    // If running locally, navigate to searchflow using React Router
    if (this.isLocalhost()) {
      return <Navigate to="/company/request/1" replace />;
    }
    
    // Show loading message while redirecting externally
    return (
      <div className='flex-center'>
        <div>Redirecting...</div>
      </div>
    );
  }
}
